var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 96,
    viewBox: "0 0 165 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9999 93.167C85.6077 93.167 88.1093 92.131 89.9531 90.2869L158.786 21.4535C162.626 17.6136 162.626 11.3871 158.786 7.54718C154.946 3.70726 148.72 3.70726 144.88 7.54718L82.9999 69.4273L21.1198 7.54718C17.2796 3.70726 11.0535 3.70726 7.21334 7.54718C3.37322 11.3871 3.37322 17.6136 7.21334 21.4535L76.0468 90.2869C77.8905 92.131 80.3921 93.167 82.9999 93.167Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.c910f6e3c56f9a33a24f5eaa5ebfd392.svg";
export { ForwardRef as ReactComponent };